import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NousLogo({ size = 'medium', showSlogan = true, alignment = 'left', variant = 'soma', onClick }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
      return;
    }
    if (variant === 'mentor') navigate('/mentor');
    else if (variant === 'soma') navigate('/soma');
    else navigate('/');
  };
  const isSmall = size === 'small';
  const isLarge = size === 'large';
  const isNav = size === 'nav';
  
  // Font sizes
  const ethosSize = isSmall ? '1.2rem' : isNav ? '1.6rem' : isLarge ? '2.8rem' : '2.0rem';
  const metricsSize = isSmall ? '1.2rem' : isNav ? '1.6rem' : isLarge ? '2.8rem' : '2.0rem';
  const sloganSize = isSmall ? '0.4rem' : isNav ? '0.45rem' : isLarge ? '0.7rem' : '0.5rem';
  
  // Padding & margins
  const glassPadding = isSmall ? '0.1rem 0.3rem' : isNav ? '0.15rem 0.4rem' : isLarge ? '0.2rem 0.8rem' : '0.15rem 0.6rem';
  const containerGap = isSmall ? '0.15rem' : isNav ? '0.2rem' : isLarge ? '0.5rem' : '0.3rem';
  const sloganMargin = isSmall ? '0.15rem' : isNav ? '0.2rem' : isLarge ? '0.5rem' : '0.35rem';
  const sloganLetterSpacing = isSmall ? '0.08em' : isLarge ? '0.16em' : '0.12em';

  return (
    <div 
      onClick={handleClick}
      style={{
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: alignment === 'center' ? 'center' : 'flex-start',
      userSelect: 'none',
      cursor: 'pointer',
    }}>
      {/* Name Container */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: containerGap,
        lineHeight: 1.1,
      }}>
        {/* "Nous" */}
        <span style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontWeight: '800',
          color: '#ffffff',
          fontSize: ethosSize,
          letterSpacing: '-0.02em',
        }}>
          Nous
        </span>
        
        <div style={{
          background: 'rgba(255, 255, 255, 0.04)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          border: `1.5px solid ${variant === 'mentor' ? 'rgba(139, 92, 246, 0.4)' : variant === 'soma' ? 'rgba(252, 76, 2, 0.4)' : 'rgba(0, 229, 255, 0.4)'}`,
          boxShadow: `0 0 15px ${variant === 'mentor' ? 'rgba(139, 92, 246, 0.25)' : variant === 'soma' ? 'rgba(252, 76, 2, 0.25)' : 'rgba(0, 229, 255, 0.25)'}, inset 0 1px 0 rgba(255,255,255,0.1)`,
          borderRadius: isSmall ? '4px' : '8px',
          padding: glassPadding,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          {/* Sub-brand text */}
          <span style={{
            fontFamily: variant === 'soma' ? "'Playfair Display', Georgia, serif" : "'Space Mono', Courier New, monospace",
            fontWeight: variant === 'soma' ? '800' : '400',
            color: 'rgba(226, 232, 240, 0.95)',
            fontSize: metricsSize,
            letterSpacing: '-0.02em',
          }}>
            {variant === 'mentor' ? 'Mentor' : variant === 'soma' ? 'Soma' : 'Metrics'}
          </span>
        </div>
      </div>
      
      {/* Slogan */}
      {showSlogan && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: alignment === 'center' ? 'center' : 'flex-start',
          marginTop: sloganMargin,
          opacity: 0.75,
        }}>
          <div style={{
            fontFamily: "'Space Mono', Courier New, monospace",
            fontSize: sloganSize,
            color: 'rgba(255, 255, 255, 0.5)',
            fontWeight: 500,
            letterSpacing: '0.02em',
          }}>
            &gt; Entrena con razón, no con emoción.
          </div>
        </div>
      )}
    </div>
  );
}
